export default {
    '抱歉！没有找到该页面': "I'm sorry! The page was not found",
    返回首页: 'Back to home page'
}
